<div class="w-auto row row-cols-12">
    <ul class="list-group p-2 m-1">
        <li class="p-0 list-group-item subheader d-block align-items-center">
            <div class="row w-100 d-flex p-1 align-items-center">
                <div class="col-6 firstcol text-truncate"><span translate>Settings.OrganisationWorkgroupsSection.Members</span></div>
                <div class="col-4 text-truncate">
                    <ng-container *ngIf="usingClearancelevel">
                        <span translate>Settings.OrganisationWorkgroupsSection.Clearance</span>
                    </ng-container>
                </div>
                <div class="col-2"></div>
            </div>
        </li>
        <li class="p-0 list-group-item d-block align-items-center" *ngFor="let workgroupMember of workgroupMembers | slice: pageSize | slice: 0:itemsPerPage; let i = index;">
            <app-memberListItem [workgroupMember]="workgroupMember" (triggerAction)="TriggerAction($event)" [usingClearancelevel]="usingClearancelevel"></app-memberListItem>
        </li>
    </ul>

    <div class="w-100">
        <ng-container *ngIf="workgroupMembers && workgroupMembers.length > 0">
            <app-page-size-picker [(ngModel)]="itemsPerPage"
                [disabled]="((filterWorkgroupMembers && filterWorkgroupMembers.count > 0 && filterWorkgroupMembers.count <= 10) || (workgroupMembers && workgroupMembers.length <= 10))"
                [collectionSize]="filterWorkgroupMembers && filterWorkgroupMembers.count > 0 ? filterWorkgroupMembers.count : filterWorkgroupMembers.count == 0 ? 1 : workgroupMembers && workgroupMembers.length"
                [currentPageNumber]="currentPage" (pageChangedTo)="onPageChanged($event)">
            </app-page-size-picker>
        </ng-container>
    </div>
</div>